// Normalize date to start of day (midnight)
export function justDate(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

// Convert Firestore Timestamp to Date
export function toDate(timestamp) {
  if (!timestamp) return null;
  if (timestamp instanceof Date) return timestamp;
  if (timestamp.toDate) return timestamp.toDate();
  if (timestamp.seconds) return new Date(timestamp.seconds * 1000);
  return new Date(timestamp);
}

// Convert date input string (YYYY-MM-DD) to Date at local noon to avoid timezone shifts
export function dateFromInput(dateString) {
  if (!dateString) return null;
  const [year, month, day] = dateString.split('-').map(Number);
  // Create date at noon local time to avoid any timezone boundary issues
  return new Date(year, month - 1, day, 12, 0, 0, 0);
}

// Convert Date to input string (YYYY-MM-DD) using local date
export function dateToInput(date) {
  if (!date) return '';
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Format date as "Jan 15, 2026"
export function formatShortDate(date) {
  if (!date) return '';
  const d = toDate(date);
  if (!d || isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
}

// Get ISO date string "2026-01-15"
export function isoDateString(date) {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Get start of week (SUNDAY instead of Monday)
export function startOfWeek(date) {
  const d = justDate(date);
  const day = d.getDay(); // 0 = Sunday, 6 = Saturday
  const diff = day; // Days since Sunday
  d.setDate(d.getDate() - diff);
  return d;
}

// Check if date is weekend (Saturday or Sunday)
export function isWeekend(date) {
  const day = new Date(date).getDay();
  return day === 0 || day === 6;
}

// Add days to date
export function addDays(date, days) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return justDate(d);
}

// Days between two dates
export function daysBetween(date1, date2) {
  const d1 = justDate(date1);
  const d2 = justDate(date2);
  const diffTime = Math.abs(d2 - d1);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

// Check if two dates are the same day
export function isSameDay(date1, date2) {
  if (!date1 || !date2) return false;
  
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  
  return d1.getFullYear() === d2.getFullYear() &&
         d1.getMonth() === d2.getMonth() &&
         d1.getDate() === d2.getDate();
}

// Check if two dates are in the same month
export function isSameMonth(date1, date2) {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
}

// Generate month grid (42 days starting from Sunday)
export function generateMonthDays(year, month) {
  const firstDay = new Date(year, month, 1);
  
  // Find Sunday of the week containing the 1st
  let startDate = startOfWeek(firstDay);
  
  // Generate 6 weeks (42 days)
  const days = [];
  let current = new Date(startDate);
  
  for (let i = 0; i < 42; i++) {
    days.push(new Date(current));
    current = addDays(current, 1);
  }
  
  return days;
}